import s from "~/pages/Logs/styles.less";
import { isArray } from "lodash";
import React from "react";
import { useTranslation } from "react-i18next";

interface ICompareLog {
  logInstance: any;
  filedKey: string;
  event: string;
}

const CompareLog = ({ logInstance, filedKey, event }: ICompareLog) => {
  const { t } = useTranslation();
  return (
    <div className={s.breakeword}>
      <b>
        {event === "edit_employee" && filedKey === "name"
          ? t(`k.namePeople`)
          : event === "edit_position" && filedKey === "code"
          ? t("k.code_position")
          : Number.isInteger(Number(filedKey))
          ? t(`k.role`)
          : filedKey.split("_")[1] === "Files"
          ? t(`k.${filedKey.split("_")[1]}`)
          : t(`k.${filedKey}`)}
        {}
      </b>{" "}
      {isArray(logInstance[filedKey]) ? (
        logInstance[filedKey].includes(null) ? (
          <span style={{ color: "red" }}>
            {Number.isInteger(Number(filedKey))
              ? t(`k.${logInstance[filedKey][0]}`)
              : logInstance[filedKey][0]}
          </span>
        ) : (
          <>
            <span style={{ color: "red" }}>
              {Number.isInteger(Number(filedKey))
                ? t(`k.${logInstance[filedKey][0]}`)
                : logInstance[filedKey][0]}
            </span>{" "}
            →{" "}
            <span style={{ color: "green" }}>
              {Number.isInteger(Number(filedKey))
                ? t(`k.${logInstance[filedKey][1]}`)
                : logInstance[filedKey][1]}
            </span>
          </>
        )
      ) : (
        <span>
          {Number.isInteger(Number(filedKey))
            ? t(`k.${logInstance[filedKey]}`)
            : logInstance[filedKey]}
        </span>
      )}
    </div>
  );
};

export default CompareLog;
